// MUI Theme
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily: ['"Montserrat"', "Open Sans"].join(","),
    fontSize: 12,
    fontWeight: 500,
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: 11,
          fontSize: 12,
        },
        root: {
          fontSize: 12,
          background: "#fff",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          padding: 4,
          fontSize: 12,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: "-0.3vh",
          fontSize: 10,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: 10,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: 10,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          fontSize: 12,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: 12,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        input: {
          fontSize: 12,
        },
        root: {
          fontSize: 12,
        },
        select: {
          fontSize: 12,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          padding: 0,
          margin: 0,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 12,
        },
      },
    },
  },
});
